var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkFillCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-335 -505) translate(318 407) translate(17 98)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#006DC9"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.051.46c-.617-.612-1.612-.612-2.229 0L5.146 6.135 2.69 3.679c-.616-.616-1.613-.616-2.229 0-.616.616-.616 1.613 0 2.229l3.571 3.571c.616.614 1.613.614 2.229 0l6.789-6.791c.614-.616.614-1.613 0-2.229l.001.001z",
    transform: "translate(8 11)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkFillCircleIcon);
export default __webpack_public_path__ + "static/media/checkmark-fill-circle-icon.1a2d03405603f85fdcf0f6869ac7e29c.svg";
export { ForwardRef as ReactComponent };